export default __webpack_public_path__ + "static/media/search-active.931ec9f3.svg";